export const adminCompaniesEndpoints = {
    base: "/api/admin/companies",
    byId: (id: number | string): string => `/api/admin/companies/${id}`,
    disable: (id: number | string): string => `/api/admin/companies/${id}/disable`,
    enable: (id: number | string): string => `/api/admin/companies/${id}/enable`,
} as const;

export const adminCompaniesQueryParams = {
    isEnabled: "is_enabled",
    search: "search",
} as const;
